export default __webpack_public_path__ + "static/media/Detour OH TRAILS App Logo_FIN_LOGO_WHT H.496f7fe6.png";